var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.geojson)?_c('LGeoJson',{attrs:{"geojson":_vm.geojson,"options":_vm.geojsonOptions}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }